<template>
  <div
    :class="errorMessage ? 'map_border--error red' : 'map_border'"
  >
    <div :id="mapId" :style="styles" />
    <span
      v-if="errorMessage"
      class="red pa-1 white--text"
    >
      {{ errorMessage }}
    </span>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  model: {
    prop: 'data',
    event: 'set-object'
  },

  props: {
    show: { type: Boolean, default: () => false },

    data: {
      type: Object,
      default: () => {}
    },

    mapId: {
      type: String,
      default: () => 'map'
    },

    dark: {
      type: Boolean,
      default: () => false
    },

    disabled: {
      type: Boolean,
      default: () => false
    },

    width: {
      type: String,
      default: () => '100%'
    },

    height: {
      type: String,
      default: () => '100%'
    },
    error: {
      type: String,
      default: () => ''
    }
  },

  data () {
    return {
      map: undefined,
      google: null,
      objectMarker: null,
      objectPolygon: null
    }
  },

  computed: {
    ...mapGetters(['color']),

    object: {
      get () {
        return this.data
      },

      set (value) {
        this.$emit('set-object', value)
      }
    },

    styles () {
      return `
        width: ${this.width};
        height: ${this.height};
        z-index: 1;
      `
    },

    errorMessage () {
      if (this.error.length > 0) {
        return this.error
      }
      return null
    }
  },

  watch: {
    show (value) {
      if (value) {
        this.validatePoint()
      } else {
        if (this.objectMarker) {
          this.removeMarker()
        }
      }
    }
  },

  beforeCreate () {
    /* eslint-disable no-undef, no-unused-vars */
    this.$googlemaps.load().then(() => {
      this.google = google
      this.initMap()
    })
    /* eslint-enable */
  },

  created () {},

  mounted () {},

  beforeDestroy () {},

  methods: {
    async initMap () {
      const self = this
      let initialLocation = { lat: 0, lng: 0 }

      this.map = new this.google.maps.Map(
        document.getElementById(this.mapId),
        {
          zoom: 16,
          center: initialLocation
        }
      )

      this.google.maps.event.addListener(this.map, 'click', function (event) {
        if (!self.disabled) {
          if (self.objectMarker) {
            self.removeMarker()
          }
          self.placeMarker(event.latLng)
        }
      })

      setTimeout(() => {
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(function (position) {
            initialLocation = new self.google.maps.LatLng(position.coords.latitude, position.coords.longitude)
            self.map.setCenter(initialLocation)
          })
        }
        this.validatePoint()
      }, 0)
    },

    drawPolygon (points) {
      const color = this.object.color
      const coors = points.map(el => {
        return {
          lat: el.latitude,
          lng: el.longitude
        }
      })
      this.objectPolygon = new this.google.maps.Polygon({
        paths: coors,
        strokeColor: color,
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: color,
        fillOpacity: 0.35
      })

      this.objectPolygon.setMap(this.map)
      this.CenterInMap(this.object.points)
    },

    CenterInMap (points) {
      const coors = points.map(el => {
        return new this.google.maps.LatLng(el.latitude, el.longitude)
      })
      var bounds = new this.google.maps.LatLngBounds()
      var i

      for (i = 0; i < coors.length; i++) {
        bounds.extend(coors[i])
      }
      this.map.setCenter(bounds.getCenter())
    },

    zoneColor (type) {
      let result = '#0070A8'
      switch (type) {
        case 'RESTRICTED':
          result = '#FFC107'
          break

        case 'DANGEROUS':
          result = '#F44336'
          break

        default:
          break
      }

      return result
    },

    removePolygon () {
      this.objectPolygon.setMap(null)
      this.objectPolygon = null
    },

    removeMarker () {
      this.objectMarker.setMap(null)
      this.objectMarker = null
    },

    placeMarker (location) {
      console.log('location :>> ', location)
      this.objectMarker = new this.google.maps.Marker({
        position: location,
        map: this.map
      })
      setTimeout(() => {
        this.map.setCenter(this.objectMarker.getPosition())
        if (!this.object.id) {
          this.object.point = Object.assign({}, {
            latitude: location.lat(),
            longitude: location.lng()
          })
        }
      }, 100)
    },

    validatePoint () {
      if (this.map && this.object.point.latitude && this.object.point.longitude) {
        if (this.objectMarker) {
          this.removeMarker()
        }
        const location = new this.google.maps.LatLng(
          this.object.point.latitude,
          this.object.point.longitude
        )
        this.placeMarker(location)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.map_border{
  border: 3px solid white;

  &--error{
    border: 3px solid  var(--v-error-base);
  }
}
</style>
